if (!customElements.get('component-notify-me')) {
  customElements.define('component-notify-me', class notifyMeComponent extends HTMLElement {
    constructor() {
      super();
      this.notifyMeContainer = this.querySelector('component-notify-me');
      this.closeNotifyMeButton = this.querySelector('.notify-content-close-btn');
      this.notifyMeEmailInput = this.querySelector('.notify-me-input-email');
      this.notifyMeSubmitButton = this.querySelector('.notify-me-button');
      this.successMessage = this.querySelector('.notify-success-form');
      this.varaiantOptions = this.querySelectorAll('.notify-me-variant');
      this.klaviyoNotifyMeRequest = new API('klaviyo', 'https://a.klaviyo.com');
      this.selectedVariantId;
    }

    _isIPhoneOrIPad = () => window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i);

    connectedCallback() {
      this.addEventListeners();
    }

    toggleNotifyMePopUp(event, selectedVariant) {
      const isIPhoneOrIPad = this._isIPhoneOrIPad();
      const body = document.querySelector('body');
      body.style.overflow = body.style.overflow === 'hidden' ? 'auto' : 'hidden';
      this.classList.toggle('hide-notify-popup');
      this.successMessage.classList.add('hidden-success-message');

      if (event === 'open') {
        if (isIPhoneOrIPad && this.closest('.section-grid-view-wrapper')) this.closest('.section-grid-view-wrapper').classList.add('notify-popup-visible');
        const optionToSelect = Array.from(this.varaiantOptions).find(varaint => selectedVariant == varaint.dataset.variantId);
        this.selectedVariantId = selectedVariant;
        optionToSelect.classList.add('notify-me-variant-selected');
      }

      if (event === 'close') {
        if (isIPhoneOrIPad && this.closest('.section-grid-view-wrapper')) this.closest('.section-grid-view-wrapper').classList.remove('notify-popup-visible');
        this.varaiantOptions.forEach((variant) => variant.classList.remove('notify-me-variant-selected'));
      }
    }

    changeSelecetdVariant(thisElement) {
      const varaiantToSelect = Array.from(this.varaiantOptions.querySelectorAll('option'));
      this.selectedVariantId = varaiantToSelect[thisElement.selectedIndex].dataset.variantId;
    }

    async notifySendEmailWhenAvailable() {
      const emailRegExr = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.notifyMeEmailInput.value);
      if (!this.notifyMeEmailInput.value || !emailRegExr) {
        alert('Please Input Valid Email');
        return;
      }

      const emailAddress = this.notifyMeEmailInput.value;
      const variantId = this.varaiantOptions ? this.selectedVariantId : this.dataset.variantId;
      this.klaviyoNotifyMe(emailAddress, variantId);
    }

    klaviyoNotifyMe(emailAddress, variantId) {
      const body = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "email": emailAddress,
                  }
              }
            },
            "channels": ["EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": "$shopify:::$default:::" + variantId
              }
            }
          }
        }
      }
      
      try {
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=H6Mx9N", {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            'revision': '2023-09-15'
          },
          body: JSON.stringify(body),
        })
          .then(response => {
            if(response.status === 202) {
              this.successMessage.classList.remove('hidden-success-message');
            }
          });
      } catch (err) {
        console.log('error', error);
      }
    }

    addEventListeners() {
      this.notifyMeSubmitButton.addEventListener('click', this.notifySendEmailWhenAvailable.bind(this));
      this.closeNotifyMeButton.addEventListener('click', this.toggleNotifyMePopUp.bind(this, 'close'));
    }
  })
}
